define([
	'internal_util/Util',
	'model/Origin'
], function (
		Util,
		Origin
		) {
	'use strict';

	/**
	 * Attribute class
	 */
	return function (name, value, origin) {
		var _name,
				_value = null,
				_origin;

		if (Util.isValidString(name)) {
			_name = name;
		} else {
			throw new Error('invalid attribute name: ' + name);
		}

		if (typeof value === 'string') {
			_value = value;
		}

		if (origin instanceof Origin) {
			_origin = origin;
		} else {
			_origin = null;
		}


		// public methods

		this.name = function () {
			return _name;
		};

		this.value = function () {
			return _value;
		};

		this.origin = function () {
			return _origin;
		};

		this.toObject = function () {
			return {
				name: _name,
				value: _value,
				origin: Util.serialize(_origin)
			};
		};
	};
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/model/Attribute.js
// module id = 55
// module chunks = 3